/* eslint-disable eol-last */
import Configuration from '../../utils/config';
import AxiosInstance from '../../interceptor/http-intercepor';
import Axios from 'axios';
import { alertService } from '../../components/toaster/alert.service';
import { loaderService } from '../../components/loader/loader.service';

class TechnicalDetailService {
    constructor() {
        this.config = new Configuration();
    }

    async addTechnicalDetail(technicalObj,rfpId) {
        loaderService.show(true);
        const self = this;
        const userId = localStorage.getItem('userId');
            
        technicalObj.userId = userId;
        technicalObj.rfpId = rfpId;
        technicalObj.overview= JSON.stringify(technicalObj.overview);
        const url = this.config.addTechnicalDetail;
        return AxiosInstance.post(url, technicalObj)
            .then((response) => {
                loaderService.show(false);
                if (response.status !== 200) {
                    this.handleResponseError(response);
                }
                return response.data;
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                self.handleError(error);
            });
    }

    async addInvitedTechnicalDetail(technicalObj,rfpId) {
        loaderService.show(true);
        const self = this;
        const userId = localStorage.getItem('userId');
            
        technicalObj.userId = userId;
        technicalObj.rfpId = rfpId;
        technicalObj.overview= JSON.stringify(technicalObj.overview);
        const url = this.config.addInvitedTechnicalDetail;
        return AxiosInstance.post(url, technicalObj)
            .then((response) => {
                loaderService.show(false);
                if (response.status !== 200) {
                    this.handleResponseError(response);
                }
                return response.data;
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                self.handleError(error);
            });
    }

    async getTechnicalDetailById(rfpId) {
        const self = this;
        loaderService.show(true);
        const userId = localStorage.getItem('userId');
        const url = this.config.getTechincalDetail + rfpId + '/' + userId;
        return AxiosInstance.get(url)
            .then((response) => {
                loaderService.show(false);
                if (response.status !== 200) {
                    this.handleResponseError(response);
                }
                return response.data;
            })
            .then((res) => {
                return res;
            })
            .catch((error) => {
                self.handleError(error);
            });
    }

    
    handleResponseError(response) {
        loaderService.show(false);
        throw new Error(`HTTP error, status = ${response.status}`);
    }

    handleError(error) {
        loaderService.show(false);
        if (error.response) {
            const autoClose = true;
            const keepAfterRouteChange = false
            alertService.error(error.response.data.message, { autoClose, keepAfterRouteChange })
            //alertService.error('Error hhh', { id: 'left-alert' });
            // Request made and server responded
            console.log(':: error', error.response.data);
            // alert(error.response.data.message);
            console.log(':: error', error.response.status);
            console.log(':: error', error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            console.log(':: error', error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log(':: Error', error.message);
        }
    }
}

export default TechnicalDetailService;